import React from 'react'
import styled from 'styled-components'
import { Autocomplete, TextField } from '../atom'

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`

const Label = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

const LabelLine = styled.div`
  width: 4px;
  height: 100%;
  border-radius: 99px;
  background: #2f3c5e;
`

const LabelName = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`

const AutoCompleteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

interface Props {
  label?: string
  options: any[]
  value?: any
  width?: number
  inputWidth?: number
  setData?: any
  fieldName?: string
}

const LabelAutoComplete = (props: Props) => {
  const { label, options, value, width, inputWidth, setData, fieldName } = props

  const handleOnchange = (newValue: any) => {
    if (!fieldName) return

    setData((prevData: any) => {
      return {
        ...prevData,
        [fieldName]: newValue,
      }
    })
  }

  return (
    <Wrapper>
      <Label>
        <LabelLine />
        <LabelName>{label || '라벨'}</LabelName>
      </Label>
      <AutoCompleteWrapper>
        <Autocomplete
          options={options || []}
          value={value || null}
          style={{
            width: width || 136,
            textAlign: 'center',
            alignItems: 'center',
          }}
          getOptionLabel={(option) => option?.name || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              style={{
                textAlign: 'center',
                alignItems: 'center',
                width: inputWidth ? `${inputWidth}px` : '180px',
              }}
              placeholder="선택해 주세요"
              variant="standard"
            />
          )}
          onChange={(event, newValue) => {
            handleOnchange(newValue)
          }}
        />
      </AutoCompleteWrapper>
    </Wrapper>
  )
}

export default LabelAutoComplete
